import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { MoveMaterialRequirementsInput, MoveMaterialStepsInput, MoveMaterialQuestionsInput } from '../../../../PathItems'
import { Thumbnail, Video, MaterialQuestionTypeOptions, MaterialQuestionValidationOptions } from '../../../../Core/PathItems'

export class CreateLesson extends RequestOperation<CreateLessonInput,Lesson> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateLesson",
      "CREATE",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteLesson extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteLesson",
      "DELETE",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateLessonName extends MessageOperation<UpdateLessonNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonName",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateLessonThumbnailUrl extends MessageOperation<UpdateLessonThumbnailUrlInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonThumbnailUrl",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateLessonVideoUrl extends MessageOperation<UpdateLessonVideoUrlInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonVideoUrl",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateLessonDescription extends MessageOperation<UpdateLessonDescriptionInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonDescription",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateLessonLongDescription extends MessageOperation<UpdateLessonLongDescriptionInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonLongDescription",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateLessonDuration extends MessageOperation<UpdateLessonDurationInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonDuration",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class CreateMaterialRequirement extends MessageOperation<MaterialRequirementValues> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateMaterialRequirement",
      "ADD",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateMaterialRequirement extends MessageOperation<MaterialRequirement> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateMaterialRequirement",
      "UPDATE",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteMaterialRequirement extends MessageOperation<string> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteMaterialRequirement",
      "REMOVE",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class CreateMaterialStep extends MessageOperation<MaterialStepValues> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateMaterialStep",
      "ADD",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateMaterialStep extends MessageOperation<MaterialStep> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateMaterialStep",
      "UPDATE",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteMaterialStep extends MessageOperation<string> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteMaterialStep",
      "REMOVE",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class AddCommand extends MessageOperation<string> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.AddCommand",
      "ADD",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class RemoveCommand extends MessageOperation<string> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.RemoveCommand",
      "REMOVE",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class CreateMaterialQuestion extends MessageOperation<MaterialQuestionValues> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateMaterialQuestion",
      "ADD",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateMaterialQuestion extends MessageOperation<MaterialQuestion> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateMaterialQuestion",
      "UPDATE",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteMaterialQuestion extends MessageOperation<string> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteMaterialQuestion",
      "REMOVE",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateLessonMinimumNumberOfCorrectAnswers extends MessageOperation<UpdateLessonMinimumNumberOfCorrectAnswersInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonMinimumNumberOfCorrectAnswers",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class MoveMaterialRequirements extends MessageOperation<MoveMaterialRequirementsInput[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.MoveMaterialRequirements",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class MoveMaterialSteps extends MessageOperation<MoveMaterialStepsInput[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.MoveMaterialSteps",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class MoveMaterialQuestions extends MessageOperation<MoveMaterialQuestionsInput[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.MoveMaterialQuestions",
      "PATCH",
      ["LessonId", "CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type Lesson = {
  id: string
  name: string
  media: Media
  details: Details
  material: Material
}

export type Media = {
  thumbnail: Thumbnail
  video: Video
}

export type Details = {
  description: string
  longDescription: string
  duration: number
}

export type Material = {
  requirements: Requirements[]
  steps: Steps[]
  questions: Questions[]
  minimumNumberOfCorrectAnswers: number
  linkedCommands: string[]
}

export type Requirements = {
  sortId: number
  requirement: MaterialRequirement
}

export type MaterialRequirement = {
  id: string
  description: string
}

export type Steps = {
  sortId: number
  step: MaterialStep
}

export type MaterialStep = {
  id: string
  name: string
  description: string
  thumbnail: Thumbnail
}

export type Questions = {
  sortId: number
  question: MaterialQuestion
}

export type MaterialQuestion = {
  id: string
  /**
   * Valid values: yesno, multiplechoice
   */
  type: string
  question: string
  typeOptions: MaterialQuestionTypeOptions
  validationOptions: MaterialQuestionValidationOptions
}

export type CreateLessonInput = {
  moduleId: string
  lessonId?: string | undefined
  name: string
  thumbnailUrl?: string | undefined
  videoUrl?: string | undefined
  description: string
  longDescription?: string | undefined
  duration?: number | undefined
}

export type UpdateLessonNameInput = {
  name: string
}

export type UpdateLessonThumbnailUrlInput = {
  url: string
}

export type UpdateLessonVideoUrlInput = {
  url: string
}

export type UpdateLessonDescriptionInput = {
  description: string
}

export type UpdateLessonLongDescriptionInput = {
  longDescription: string
}

export type UpdateLessonDurationInput = {
  duration: number
}

export type MaterialRequirementValues = {
  description: string
}

export type MaterialStepValues = {
  name: string
  description: string
  thumbnail: Thumbnail
}

export type MaterialQuestionValues = {
  /**
   * Valid values: yesno, multiplechoice
   */
  type: string
  question: string
  typeOptions: MaterialQuestionTypeOptions
  validationOptions: MaterialQuestionValidationOptions
}

export type UpdateLessonMinimumNumberOfCorrectAnswersInput = {
  minimumNumberOfCorrectAnswers: number
}

